import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml, validateNoNegativeNumber } from '../../../utils/textFunctions'
import '../../../styles/assets/css/pages/form1.css'
import '../../../styles/assets/css/pages/form3.css'
import { loadLocationWithMessage } from '../../../actions/location'

import '../../../styles/assets/css/pages/stepper1.css'
import { registration_steps } from '../variables/registration.js'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'

import WarningIcon from '@material-ui/icons/Warning'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import CancelIcon from '@material-ui/icons/Cancel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import { smoke_often, yes_no, days_per_week, reason_stopping, diagnosed,
  diabetes, hypertension, med_category, provider_often } from '../variables/medical_history.js'
import { initAutosaveForForm2 } from '../../utils/draftAutosaveManager';

class MedicalHistory extends Component {
  constructor(props) {
      super(props)
      //var [fields, setFields] = useState([{ value: null }])
      this.state = {
        status: false,
        status_submit: true,
        invalid: false,
        message: '',
        uid: 0,
        smoke: 0,
        smoke_often: 0,
        exercise: 0,
        exercise_days: 0,
        mindbody: 0,
        mindbody_days: 0,
        med_antidepressants: [{ id:1, med: 0, taking: 0, dose: 0, taken: 0, reason: 0 }],
        med_anticonvulsants: [{ id:1, med: 0, taking: 0, dose: 0, taken: 0, reason: 0 }],
        med_mood_stabilizers: [{ id:1, med: 0, taking: 0, dose: 0, taken: 0, reason: 0 }],
        med_antipsychotics: [{ id:1, med: 0, taking: 0, dose: 0, taken: 0, reason: 0 }],
        med_anxiolytics: [{ id:1, med: 0, taking: 0, dose: 0, taken: 0, reason: 0 }],
        med_anticholinergic: [{ id:1, med: 0, taking: 0, dose: 0, taken: 0, reason: 0 }],
        med_antihistamine: [{ id:1, med: 0, taking: 0, dose: 0, taken: 0, reason: 0 }],
        med_sedatives: [{ id:1, med: 0, taking: 0, dose: 0, taken: 0, reason: 0 }],
        med_other: [{ id:1, med: '', taking: 0, dose: 0, taken: 0, reason: 0 }],
        diagnosed: [],
        diagnosed_1: 0,
        diagnosed_2: 0,
        diagnosed_3: 0,
        diagnosed_4: 0,
        diagnosed_5: 0,
        diagnosed_6: 0,
        diagnosed_7: 0,
        diagnosed_8: 0,
        diagnosed_9: 0,
        diagnosed_10: 0,
        diagnosed_11: 0,
        diagnosed_12: 0,
        diagnosed_13: 0,
        diagnosed_14: 0,
        diagnosed_15: 0,
        diagnosed_16: 0,
        diagnosed_17: 0,
        diagnosed_18: 0,
        diagnosed_19: 0,
        diagnosed_20: 0,
        diagnosed_21: 0,
        diagnosed_22: 0,
        diagnosed_23: 0,
        diagnosed_brain_date: '',
        diagnosed_brain_text: '',
        diagnosed_diabetes: 0,
        diagnosed_hypertension: 0,
        diagnosed_cancer_txt: '',
        diagnosed_other: '',
        nonpsyciatric_med: [{ id:1, med: '', dose: 0 }],
        medication_list: [],
        pcp_name: '',
        pcp_contact: '',
        therapist_name: '',
        therapist_contact: '',
        therapist_often: 0,
        therapist_often_other: '',
        therapist_list: [{ id: 1, name: '', contact: '', therapist_often: 0, therapist_often_other: '', }],
        prescriber_name: '',
        prescriber_contact: '',
        prescriber_often: '',
        prescriber_often_other: '',
      }
      this.answerFields = [
        // primitives / scalars
        'status','status_submit','invalid','message','uid',
        'smoke','smoke_often','exercise','exercise_days','mindbody','mindbody_days',
        'diagnosed_1','diagnosed_2','diagnosed_3','diagnosed_4','diagnosed_5',
        'diagnosed_6','diagnosed_7','diagnosed_8','diagnosed_9','diagnosed_10',
        'diagnosed_11','diagnosed_12','diagnosed_13','diagnosed_14','diagnosed_15',
        'diagnosed_16','diagnosed_17','diagnosed_18','diagnosed_19','diagnosed_20',
        'diagnosed_21','diagnosed_22','diagnosed_23',
        'diagnosed_brain_date','diagnosed_brain_text','diagnosed_diabetes','diagnosed_hypertension',
        'diagnosed_cancer_txt','diagnosed_other',
        'pcp_name','pcp_contact',
        'therapist_name','therapist_contact','therapist_often','therapist_often_other',
        'prescriber_name','prescriber_contact','prescriber_often','prescriber_often_other',

        // arrays of objects (DO persist)
        'med_antidepressants','med_anticonvulsants','med_mood_stabilizers',
        'med_antipsychotics','med_anxiolytics','med_anticholinergic',
        'med_antihistamine','med_sedatives','med_other','nonpsyciatric_med',
        'therapist_list',

        // arrays (checkbox/multi)
        'diagnosed'
      ]

      // numeric scalar fields (coerce on hydrate)
      this.numericFields = new Set([
        'smoke','smoke_often','exercise','exercise_days','mindbody','mindbody_days',
        'diagnosed_1','diagnosed_2','diagnosed_3','diagnosed_4','diagnosed_5','diagnosed_6',
        'diagnosed_7','diagnosed_8','diagnosed_9','diagnosed_10','diagnosed_11','diagnosed_12',
        'diagnosed_13','diagnosed_14','diagnosed_15','diagnosed_16','diagnosed_17','diagnosed_18',
        'diagnosed_19','diagnosed_20','diagnosed_21','diagnosed_22','diagnosed_23',
        'diagnosed_diabetes','diagnosed_hypertension',
        'therapist_often','prescriber_often'
      ])

      // array-typed fields (parse JSON on hydrate)
      this.arrayFields = new Set([
        'med_antidepressants','med_anticonvulsants','med_mood_stabilizers',
        'med_antipsychotics','med_anxiolytics','med_anticholinergic',
        'med_antihistamine','med_sedatives','med_other','nonpsyciatric_med',
        'therapist_list','diagnosed'
      ])

      // helper for saving arrays after setState
      this._saveArray = (name) => this._draft?.savePartial(name, this.state[name], this.state)
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    // init autosave (14 days)
    this._draft = initAutosaveForForm2(this, {
      formId: 'medical_history',
      fields: this.answerFields,
      expireMs: 14 * 24 * 60 * 60 * 1000,
      // coerce on hydrate
      coerceIn: (name, v) => {
        if (this.arrayFields.has(name) && Array.isArray(v)) return v;
        if (this.numericFields.has(name)) {
          const n = Number(v);
          return Number.isNaN(n) ? v : n;
        }
        return v;
      }
    });
    this.getRegistraionProcess()
  }

  componentWillUnmount() {
    this._draft?.detach();
  }

  getRegistraionProcess = () => {
    axios({
      method: 'post',
      url: connectNode + 'patient/registration/get_registration_process',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { uid: this.props.authReducer.uid }
    })
    .then((result) => {
        if(result['data'].reg_step !== 'medical_history') {
          this.props.history.push('/member/'+result['data'].reg_step)
        }
        axios({
          method: 'post',
          url: connectNode + 'patient/registration/get_medication_list',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: { }
        })
        .then((list) => {
            this.setState({
              medication_list: list['data'],
            })
            }
        )
      }
    )
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: escapeHtml(value) }, () =>
      this._draft?.savePartial(name, this.state[name], this.state)
    );
  }

  handleChange2 = (e) => {
    const { name, value } = e.target; // radios -> "1"/"2"
    this.setState({ [name]: value }, () =>
      this._draft?.savePartial(name, this.state[name], this.state)
    );
  }

  handleChange3 = (e, name, id, field) => {
    const arr = [...this.state[name]];
    arr[id] = { ...arr[id], [field]: escapeHtml(e.target.value) };
    this.setState({ [name]: arr }, () => this._saveArray(name));
  }

  handleChange4 = (e, name) => {
    const value = e.target.value;
    this.setState({ [name]: value }, () =>
      this._draft?.savePartial(name, this.state[name], this.state)
    );
  }

  handleChange5 = (e, name, id, field) => {
    const arr = [...this.state[name]];
    arr[id] = { ...arr[id], [field]: e.target.value };
    this.setState({ [name]: arr }, () => this._saveArray(name));
  }
  handleChange5_1 = (e, name, id, field) => {
    const arr = [...this.state[name]];
    arr[id] = { ...arr[id], [field]: validateNoNegativeNumber(e.target.value) };
    if (arr[id][field] != null && arr[id][field] != undefined) {
      this.setState({ [name]: arr }, () => this._saveArray(name));
    }
  }

  handleChange5_2 = (e, name, id, field) => {
    const arr = [...this.state[name]];
    arr[id] = { ...arr[id], [field]: e.target.value };
    if (arr[id][field] != null && arr[id][field] != undefined) {
      this.setState({ [name]: arr }, () => this._saveArray(name));
    }
  }

  handleChange6 = (e, name, field) => {
    const arr = Array.isArray(field) ? [...field] : [];
    if (e.target.checked) arr.push(+e.target.value);
    else {
      const i = arr.indexOf(+e.target.value);
      if (i > -1) arr.splice(i, 1);
    }
    this.setState({ [name]: arr }, () => this._saveArray(name));
  };

  handleChange7 = (e) => {
    const { name, checked } = e.target;
    const val = checked ? 1 : 0;
    this.setState({ [name]: val }, () =>
      this._draft?.savePartial(name, this.state[name], this.state)
    );
  };

  validateMed = (name) => {
    var getMed = this.state[name]
    var st = true
    getMed.map(each => {
      if(each.med > 0 && each.taking === '1' &&
        (each.dose === 0 || each.dose === '0')) {
          st = false
      }
    })
    return st
  }

  handleSubmit = (e) => {
    e.preventDefault()
    //console.log(this.state)
    if(this.state.pcp_name.trim().length == 0 || this.state.pcp_contact.trim().length == 0){
        this.setState({
          message: 'Please answer question 1',
          invalid: true,
        })
        window.scrollTo(0, 0)
    } else if(this.state.prescriber_name.trim().length == 0){
        this.setState({
          message: 'Please provide the name of your medication prescriber',
          invalid: true,
        })
        window.scrollTo(0, 0)
    } else if(this.state.smoke == 0 || (this.state.smoke == 1 && this.state.smoke_often == 0)){
        this.setState({
          message: 'Please select an answer for question 2',
          invalid: true,
        })
        window.scrollTo(0, 0)
    } else if(this.state.mindbody == 0
      || (this.state.mindbody == 1 && this.state.mindbody_days == 0)){
        this.setState({
          message: 'Please select an answer for question 3',
          invalid: true,
        })
        window.scrollTo(0, 0)
      } else if (
        diagnosed.some(each => {
          const answer = Number(this.state[`diagnosed_${each.value}`]);
          return answer !== 1 && answer !== 2; })
      ) {
        this.setState({
          message: 'Please answer Yes or No for every condition in question 6',
          invalid: true,
        });
        window.scrollTo(0, 0);
    } else {
      let st_med_valid = true
      var med_list = ['med_antidepressants', 'med_anticonvulsants', 'med_mood_stabilizers',
                      'med_antipsychotics', 'med_anxiolytics', 'med_anticholinergic',
                      'med_antihistamine', 'med_sedatives', 'med_other']
      med_list.map(med => {
        if(!this.validateMed(med)) {
          st_med_valid = this.validateMed(med)
        }
      })
      if(!st_med_valid) {
        this.setState({
          message: 'Please fill in the total daily dosage',
          invalid: true,
        })
        window.scrollTo(0, 0)
      } else {
        this.setState({
          status_submit: false,
          message: '',
        })
        axios({
          method: 'post',
          url: connectNode + 'patient/registration/update_medical_history',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: {
            uid: this.props.authReducer.uid,
            user: this.state,
          }
        })
        .then((result) => {
          if(result['data'] === 'psychiatric_history') {
            this._draft?.clear();
            this.props.onLoadLocation('/member/psychiatric_history')
            this.props.history.push('/member/psychiatric_history')
          }
        })
      }
    }
  }

  appendInputMedication = (name, fields) => {
    const newId = fields[fields.length - 1].id + 1;
    this.setState(prev => ({
      [name]: prev[name].concat([{ id: newId, med: 0, taking: 0, dose: 0, taken: 0, reason: 0 }])
    }), () => this._saveArray(name));
  };

  appendInputMedication2 = (name, fields) => {
    const newId = fields[fields.length - 1].id + 1;
    this.setState(prev => ({
      [name]: prev[name].concat([{ id: newId, med: '', taking: 0, dose: 0, taken: 0, reason: 0 }])
    }), () => this._saveArray(name));
  };

  appendInputMedication3 = (name, fields) => {
    const newId = fields[fields.length - 1].id + 1;
    this.setState(prev => ({
      [name]: prev[name].concat([{ id: newId, med: '', dose: 0 }])
    }), () => this._saveArray(name));
  };

  removeInputSet1 = (name, id, fields) => {
    const next = fields.filter(x => x.id !== id || id === 1); // keep row 1
    this.setState({ [name]: next }, () => this._saveArray(name));
  };

  appendInputTherapist = (name, fields) => {
    const newId = fields[fields.length - 1].id + 1;
    this.setState(prev => ({
      [name]: prev[name].concat([{ id: newId, name: '', contact: '', therapist_often: 0, therapist_often_other: '' }])
    }), () => this._saveArray(name));
  };

  render() {
    //console.log(this.state)
    return (
      <div className="medical_history box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Medical History
          </div>
          <div className="small-12 columns stepper">
            <Stepper alternativeLabel nonLinear activeStep={8}>
              {registration_steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>
        </div>
        { this.state.message !== '' &&
        <div className="row warning_msg6">
          <div className="small-12 columns ">
            <div className="float_left1"><WarningIcon /></div>
            <div className="txt_warning_msg1">{ this.state.message }</div>
          </div>
        </div>
        }
        <div className="row">
          <div className="small-12 columns box2_1">
          <b>IMPORTANT: </b>
          If you cannot complete this section in one sitting, you may return and finish it <b>on this device</b> without losing your data.
          </div>
          <div className="small-12 columns ">
            <div className="box_border5">
              <form id="general_information">
                <div className="row">
                  <div className="small-12 columns box1">
                    <div className="title_topic1">1. Please provide the name and contact information of your primary care provider (PCP).</div>
                    <div className="small-12 columns q_pcp">
                      <div className="row  ">
                        <div className="small-12 medium-3 columns bold top_space1 align_right">
                          Name:
                        </div>
                        <div className="small-12 medium-9 columns">
                        <TextField label="" variant="outlined" value={this.state.pcp_name}
                        InputProps={{ inputProps: { name: "pcp_name", maxLength: 50 }}} name="pcp_name"
                        onChange={(e) => this.handleChange4(e, 'pcp_name')} />
                        </div>
                      </div>
                      <div className="row  ">
                        <div className="small-12 medium-3 columns bold top_space1 align_right">
                          Email/Phone:
                        </div>
                        <div className="small-12 medium-9 columns">
                        <TextField label="" variant="outlined" value={this.state.pcp_contact}
                        InputProps={{ inputProps: { name: "pcp_contact", maxLength: 100 }}} name="pcp_contact"
                        onChange={(e) => this.handleChange4(e, 'pcp_contact')} />
                        </div>
                      </div>
                    </div>
                    <div className="small-12 columns title_topic1 top_space1">Please provide name and contact information of your medication prescriber if not your PCP (psychiatrist, psychopharmacologist or psychiatric nurse practitioner).</div>
                    <div className="small-12 columns q_pcp">
                      <div className="row  ">
                        <div className="small-12 medium-3 columns bold top_space1 align_right">
                          Name:
                        </div>
                        <div className="small-12 medium-9 columns">
                        <TextField label="" variant="outlined" value={this.state.prescriber_name}
                        InputProps={{ inputProps: { name: "prescriber_name", maxLength: 50 }}} name="prescriber_name"
                        onChange={(e) => this.handleChange4(e, 'prescriber_name')} />
                        </div>
                      </div>
                      <div className="row  ">
                        <div className="small-12 medium-3 columns bold top_space1 align_right">
                          Email/Phone:
                        </div>
                        <div className="small-12 medium-9 columns">
                        <TextField label="" variant="outlined" value={this.state.prescriber_contact}
                        InputProps={{ inputProps: { name: "prescriber_contact", maxLength: 100 }}} name="prescriber_contact"
                        onChange={(e) => this.handleChange4(e, 'prescriber_contact')} />
                        </div>
                      </div>
                      <div className="row  ">
                        <div className="small-12 medium-3 columns bold top_space1 align_right">
                          Frequency of visits:
                        </div>
                        <div className="small-12 medium-9 columns">
                        <div className="w95p">
                          <FormControl variant="outlined">
                            <Select value={this.state.prescriber_often} variant="outlined"
                              label="" defaultValue=""
                              onChange={(e) => this.handleChange4(e, 'prescriber_often', 'val')}>
                                {provider_often.map(each =>
                                  <MenuItem key={"po"+each.value} value={each.value}>{each.label}</MenuItem>
                                )}
                            </Select>
                          </FormControl>
                        </div>
                        </div>
                      </div>
                      {this.state.prescriber_often == 4 &&
                      <div className="row">
                        <div className="medium-3 columns bold top_space1 align_right">
                          &nbsp;
                        </div>
                        <div className="small-12 medium-9 columns">
                        <TextField label="" variant="outlined" value={this.state.prescriber_often_other}
                        InputProps={{ inputProps: { name: "prescriber_often_other", maxLength: 100, placeholder: 'Specify frequency', }}}
                        name="prescriber_often_other"
                        onChange={(e) => this.handleChange4(e, 'prescriber_often_other')} />
                        </div>
                      </div>}
                    </div>
                    <div className="small-12 columns title_topic1 top_space1">If you see a therapist(s) outside of FITT-BD, please provide name and contact information.</div>
                    {this.state.therapist_list.map((val, index) =>
                    <div className="small-12 columns q_pcp">
                      <div className="row  ">
                        <div className="small-12 medium-3 columns bold top_space1 align_right">
                          Name:
                        </div>
                        <div className="small-12 medium-8 columns">
                        <TextField label="" variant="outlined" value={this.state.therapist_list[index].name}
                        InputProps={{ inputProps: { maxLength: 50 }}}
                        onChange={(e) => this.handleChange5_2(e, 'therapist_list', index, 'name')}
                        variant="outlined" value={this.state.therapist_list[index].name} />
                        </div>
                        <div className="small-12 medium-1 columns">&nbsp;</div>
                      </div>
                      <div className="row  ">
                        <div className="small-12 medium-3 columns bold top_space1 align_right">
                          Email/Phone:
                        </div>
                        <div className="small-12 medium-8 columns">
                        <TextField label="" variant="outlined" value={this.state.therapist_list[index].contact}
                        InputProps={{ inputProps: { maxLength: 100 }}}
                        onChange={(e) => this.handleChange5_2(e, 'therapist_list', index, 'contact')}
                        variant="outlined" value={this.state.therapist_list[index].contact} />
                        </div>
                        <div className="small-12 medium-1 columns align_left">
                        {val.id > 1 && <CancelIcon onClick={ () => this.removeInputSet1('therapist_list', val.id, this.state.therapist_list) } />}
                        </div>
                      </div>
                      <div className="row  ">
                        <div className="small-12 medium-3 columns bold top_space1 align_right">
                          Frequency of visits:
                        </div>
                        <div className="small-12 medium-8 columns">
                        <div className="w95p top_space4">
                          <FormControl variant="outlined">
                            <Select value={this.state.therapist_list[index].therapist_often} variant="outlined"
                              label="" defaultValue=""
                              onChange={(e) => this.handleChange5_2(e, 'therapist_list', index, 'therapist_often')}>
                                {provider_often.map(each =>
                                  <MenuItem key={"po"+each.value} value={each.value}>{each.label}</MenuItem>
                                )}
                            </Select>
                          </FormControl>
                        </div>
                        </div>
                        <div className="medium-1 columns">&nbsp;</div>
                      </div>
                      {this.state.therapist_list[index].therapist_often == 4 &&
                      <div className="row">
                        <div className="medium-3 columns bold top_space1 align_right">
                          &nbsp;
                        </div>
                        <div className="small-12 medium-8 columns">
                        <TextField label="" variant="outlined" value={this.state.therapist_list[index].therapist_often_other}
                        InputProps={{ inputProps: { name: "therapist_often_other", maxLength: 100, placeholder: 'Specify frequency', }}}
                        name="prescriber_often_other"
                        onChange={(e) => this.handleChange5_2(e, 'therapist_list', index, 'therapist_often_other')} />
                        </div>
                        <div className="medium-1 columns">&nbsp;</div>
                      </div>}
                    </div>)}
                    <div className="small-12 columns top_space1">
                      <button type="button" className="addInput1"
                         onClick={ () => this.appendInputTherapist('therapist_list', this.state.therapist_list) }>
                          Add Therapist
                      </button>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="small-12 columns box1">
                    <div className="title_topic1">2. Have you smoked tobacco within the past year?</div>
                    <div className="row">
                      <div className="small-12 columns frm_space1 q1_smoke">
                        {yes_no.map(each =>
                          <div className="each_radio1" key={"sm"+each.value}>
                          <input type="radio" name="smoke"
                            key={"smoke"+each.value} value={each.value}
                            checked={this.state.smoke == each.value}
                            onChange={(e) => this.handleChange2(e)}/>
                            {each.label}</div>)}
                      </div>
                    </div>
                    {this.state.smoke == 1 &&
                    <div className="row top_space">
                      <div className="small-12 medium-6 columns frm_space1">
                        <div className="title_space1"><ArrowRightIcon /> How often?</div>
                        <div className="frm_space2 left_space1">
                          <FormControl variant="outlined">
                            <Select value={this.state.smoke_often} variant="outlined"
                              label="" defaultValue=""
                              onChange={(e) => this.handleChange4(e, 'smoke_often', 'val')}>
                                {smoke_often.map(each =>
                                  <MenuItem key={"smoke_often"+each.value} value={each.value}>{each.label}</MenuItem>
                                )}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>}
                  </div>
                </div>

                <div className="row">
                  <div className="small-12 columns box1">
                    <div className="title_topic1">3.	Do you currently practice any mind-body techniques (e.g., meditation, relaxation, repetitive prayer, yoga)?</div>
                    <div className="row">
                      <div className="small-12 columns frm_space1 q1_smoke">
                        {yes_no.map(each =>
                          <div className="each_radio1" key={"mindbody"+each.value}>
                            <input type="radio" name="mindbody" value={each.value}
                                checked={this.state.mindbody == each.value}
                                onChange={(e) => this.handleChange2(e)}/>
                                {each.label}</div>
                        )}
                      </div>
                    </div>
                    {this.state.mindbody == 1 &&
                    <div className="row top_space">
                      <div className="small-12 columns float_left2">
                        <div className="title_space1"><ArrowRightIcon /> How many days of the week do you practice any of these techniques?</div>
                      </div>
                      <div className="small-12 medium-6 columns float_left2">
                        <div className="frm_space2 left_space1">
                          <FormControl variant="outlined">
                            <Select value={this.state.mindbody_days} variant="outlined"
                              label="" defaultValue=""
                              onChange={(e) => this.handleChange4(e, 'mindbody_days', 'val')}>
                                {days_per_week.map(each =>
                                  <MenuItem key={"mindbody_days"+each.value} value={each.value}>{each.label}</MenuItem>
                                )}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>}
                  </div>
                </div>

                <div className="row">
                  <div className="small-12 columns box1 q4">
                    <div className="title_topic1">4. Please indicate the psychiatric medications you have taken in the past or are currently taking:</div>
                    <div className="row">
                      <div className="small-12 columns">
                        {/* Category 1 */}
                        <div className="q4_category">
                          <div className="small-12 columns frm_space1 title_topic2">
                            Antidepressants
                          </div>
                          <div className="small-12 columns ">
                            <div className="frm_space2">
                            {this.state.med_antidepressants.map((val, index) =>
                              <div className="row each_m_set" key={"m_antidep"+val.id} >
                                <div className="small-12 columns sep_line1">&nbsp;</div>
                                <div className="small-12 medium-4 columns float_left">
                                  {val.id > 1 && <CancelIcon onClick={ () => this.removeInputSet1('med_antidepressants', val.id, this.state.med_antidepressants) } />}
                                  <FormControl variant="outlined">
                                    <Select value={this.state.med_antidepressants[index].med} variant="outlined"
                                      label="Select medication"
                                      onChange={(e) => this.handleChange5(e, 'med_antidepressants', index, 'med')}>
                                      {(this.state.medication_list[med_category.find(y => y.label === "antidepressants").value] ?? []).map(each =>
                                        <MenuItem key={"antidepressants"+each.med_id} value={each.med_id}>{each.med_name}</MenuItem>
                                      )}
                                    </Select>
                                  </FormControl>
                                </div>
                                { this.state.med_antidepressants[index].med > 0 &&
                                <div className="small-12 medium-8 columns q4_each">
                                  <div className="row">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        Are you currently taking this medication?
                                      </div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_depressants_taking"+index+each.value} >
                                            <input type="radio" value={each.value}
                                                checked={this.state.med_antidepressants[index].taking == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_antidepressants', index, 'taking')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  { this.state.med_antidepressants[index].taking == 1 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        What is the recommended total daily dose?
                                      </div>
                                      <div className="med_q1_ans">
                                        <TextField label="" type="number"
                                        onChange={(e) => this.handleChange5_1(e, 'med_antidepressants', index, 'dose')}
                                        variant="outlined" value={this.state.med_antidepressants[index].dose}
                                        InputProps={{ maxLength: 10 }}  />
                                      </div>
                                      <div className="med_q1_detail">mg</div>
                                    </div>
                                  </div>}
                                  { this.state.med_antidepressants[index].taking == 2 &&
                                  <div className="row top_space2">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Taken for at least 3 months?</div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_depressants_3m"+index+each.value} >
                                            <input type="radio" value={each.value}
                                                checked={this.state.med_antidepressants[index].taken == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_antidepressants', index, 'taken')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>}
                                  { this.state.med_antidepressants[index].taking == 2 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Reason for stopping</div>
                                      <div className="med_q1_ans q4_reason">
                                      <FormControl variant="outlined">
                                        <Select value={this.state.med_antidepressants[index].reason} variant="outlined"
                                          onChange={(e) => this.handleChange5(e, 'med_antidepressants', index, 'reason')}>
                                          {reason_stopping.map(each =>
                                            <MenuItem key={"at_depressants_rs"+index+each.value} value={each.value}>{each.label}</MenuItem>
                                          )}
                                        </Select>
                                      </FormControl>
                                      </div>
                                    </div>
                                  </div>}

                                </div>}
                              </div>
                            )} {/* End row */}

                            </div>
                            <div className="small-12 columns sep_line1">&nbsp;</div>
                          </div>
                          <div className="small-12 columns ">
                            <button type="button" className="addInput1"
                               onClick={ () => this.appendInputMedication('med_antidepressants', this.state.med_antidepressants) }>
                                Add Another Medication
                            </button>
                          </div>
                        </div>{/*End Category*/}
                        {/* Category 2 */}
                        <div className="q4_category">
                          <div className="small-12 columns frm_space1 title_topic2">
                            Anticonvulsants / Mood Stabilizers
                          </div>
                          <div className="small-12 columns ">
                            <div className="frm_space2">

                            {this.state.med_anticonvulsants.map((val, index) =>
                              <div className="row each_m_set" key={"m_anticon"+val.id} >
                                <div className="small-12 columns sep_line1">&nbsp;</div>
                                <div className="small-12 medium-4 columns float_left">
                                  {val.id > 1 && <CancelIcon onClick={ () => this.removeInputSet1('med_anticonvulsants', val.id, this.state.med_anticonvulsants) } />}
                                  <FormControl variant="outlined">
                                    <Select value={this.state.med_anticonvulsants[index].med} variant="outlined"
                                      label="Select medication"
                                      onChange={(e) => this.handleChange5(e, 'med_anticonvulsants', index, 'med')}>
                                      {(this.state.medication_list[med_category.find(y => y.label === "anticonvulsants").value] ?? []).map(each =>
                                        <MenuItem key={"anticonvulsants"+each.med_id} value={each.med_id}>{each.med_name}</MenuItem>
                                      )}
                                    </Select>
                                  </FormControl>
                                </div>
                                { this.state.med_anticonvulsants[index].med > 0 &&
                                <div className="small-12 medium-8 columns q4_each">
                                  <div className="row">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        Are you currently taking this medication?
                                      </div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_anticon_taking"+index+each.value} >
                                            <input type="radio" value={each.value}
                                                checked={this.state.med_anticonvulsants[index].taking == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_anticonvulsants', index, 'taking')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  { this.state.med_anticonvulsants[index].taking == 1 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        What is the recommended total daily dose?
                                      </div>
                                      <div className="med_q1_ans">
                                        <TextField label="" type="number"
                                        onChange={(e) => this.handleChange5_1(e, 'med_anticonvulsants', index, 'dose')}
                                        variant="outlined" value={this.state.med_anticonvulsants[index].dose}
                                        InputProps={{ maxLength: 10 }}  />
                                      </div>
                                      <div className="med_q1_detail">mg</div>
                                    </div>
                                  </div>}
                                  { this.state.med_anticonvulsants[index].taking == 2 &&
                                  <div className="row top_space2">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Taken for at least 3 months?</div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_depressants_3m"+index+each.value} >
                                            <input type="radio" value={each.value}
                                                checked={this.state.med_anticonvulsants[index].taken == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_anticonvulsants', index, 'taken')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>}
                                  { this.state.med_anticonvulsants[index].taking == 2 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Reason for stopping</div>
                                      <div className="med_q1_ans q4_reason">
                                      <FormControl variant="outlined">
                                        <Select value={this.state.med_anticonvulsants[index].reason} variant="outlined"
                                          onChange={(e) => this.handleChange5(e, 'med_anticonvulsants', index, 'reason')}>
                                          {reason_stopping.map(each =>
                                            <MenuItem key={"at_conv_rs"+index+each.value} value={each.value}>{each.label}</MenuItem>
                                          )}
                                        </Select>
                                      </FormControl>
                                      </div>
                                    </div>
                                  </div>}

                                </div>}
                              </div>
                            )} {/* End row */}
                            </div>
                            <div className="small-12 columns sep_line1">&nbsp;</div>
                          </div>
                          <div className="small-12 columns ">
                            <button type="button" className="addInput1"
                               onClick={ () => this.appendInputMedication('med_anticonvulsants', this.state.med_antidepressants) }>
                                Add Another Medication
                            </button>
                          </div>
                        </div>{/*End Category*/}
                        {/* Category 4 */}
                        <div className="q4_category">
                          <div className="small-12 columns frm_space1 title_topic2">
                            Antipsychotics
                          </div>
                          <div className="small-12 columns ">
                            <div className="frm_space2">
                            {this.state.med_antipsychotics.map((val, index) =>
                              <div className="row each_m_set" key={"m_antipsy"+val.id} >
                                <div className="small-12 columns sep_line1">&nbsp;</div>
                                <div className="small-12 medium-4 columns float_left">
                                  {val.id > 1 && <CancelIcon onClick={ () => this.removeInputSet1('med_antipsychotics', val.id, this.state.med_antipsychotics) } />}
                                  <FormControl variant="outlined">
                                    <Select value={this.state.med_antipsychotics[index].med} variant="outlined"
                                      label="Select medication"
                                      onChange={(e) => this.handleChange5(e, 'med_antipsychotics', index, 'med')}>
                                      {(this.state.medication_list[med_category.find(y => y.label === "antipsychotic").value] ?? []).map(each =>
                                        <MenuItem key={"antipsychotic"+each.med_id} value={each.med_id}>{each.med_name}</MenuItem>
                                      )}
                                    </Select>
                                  </FormControl>
                                </div>
                                { this.state.med_antipsychotics[index].med > 0 &&
                                <div className="small-12 medium-8 columns q4_each">
                                  <div className="row">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        Are you currently taking this medication?
                                      </div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_anticon_taking"+index+each.value} >
                                            <input type="radio"
                                            value={each.value}
                                            checked={this.state.med_antipsychotics[index].taking == each.value}
                                            onChange={(e) => this.handleChange5(e, 'med_antipsychotics', index, 'taking')}/>
                                            {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  { this.state.med_antipsychotics[index].taking == 1 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        What is the recommended total daily dose?
                                      </div>
                                      <div className="med_q1_ans">
                                        <TextField label="" type="number"
                                        onChange={(e) => this.handleChange5_1(e, 'med_antipsychotics', index, 'dose')}
                                        variant="outlined" value={this.state.med_antipsychotics[index].dose}
                                        InputProps={{ maxLength: 10 }}  />
                                      </div>
                                      <div className="med_q1_detail">mg</div>
                                    </div>
                                  </div>}
                                  { this.state.med_antipsychotics[index].taking == 2 &&
                                  <div className="row top_space2">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Taken for at least 3 months?</div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_psychotic"+index+each.value} >
                                            <input type="radio" value={each.value}
                                                checked={this.state.med_antipsychotics[index].taken == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_antipsychotics', index, 'taken')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>}
                                  { this.state.med_antipsychotics[index].taking == 2 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Reason for stopping</div>
                                      <div className="med_q1_ans q4_reason">
                                      <FormControl variant="outlined">
                                        <Select value={this.state.med_antipsychotics[index].reason} variant="outlined"
                                          onChange={(e) => this.handleChange5(e, 'med_antipsychotics', index, 'reason')}>
                                          {reason_stopping.map(each =>
                                            <MenuItem key={"at_conv_rs"+index+each.value} value={each.value}>{each.label}</MenuItem>
                                          )}
                                        </Select>
                                      </FormControl>
                                      </div>
                                    </div>
                                  </div>}

                                </div>}
                              </div>
                            )} {/* End row */}
                            </div>
                            <div className="small-12 columns sep_line1">&nbsp;</div>
                          </div>
                          <div className="small-12 columns ">
                            <button type="button" className="addInput1"
                               onClick={ () => this.appendInputMedication('med_antipsychotics', this.state.med_antipsychotics) }>
                                Add Another Medication
                            </button>
                          </div>
                        </div>{/*End Category*/}
                        {/* Category 5 */}
                        <div className="q4_category">
                          <div className="small-12 columns frm_space1 title_topic2">
                            Anxiolytics
                          </div>
                          <div className="small-12 columns ">
                            <div className="frm_space2">
                            {this.state.med_anxiolytics.map((val, index) =>
                              <div className="row each_m_set" key={"m_anxio"+val.id} >
                                <div className="small-12 columns sep_line1">&nbsp;</div>
                                <div className="small-12 medium-4 columns float_left">
                                  {val.id > 1 && <CancelIcon onClick={ () => this.removeInputSet1('med_anxiolytics', val.id, this.state.med_anxiolytics) } />}
                                  <FormControl variant="outlined">
                                    <Select value={this.state.med_anxiolytics[index].med} variant="outlined"
                                      label="Select medication"
                                      onChange={(e) => this.handleChange5(e, 'med_anxiolytics', index, 'med')}>
                                      {(this.state.medication_list[med_category.find(y => y.label === "anxiolytics").value] ?? []).map(each =>
                                        <MenuItem key={"anxiolytics"+each.med_id} value={each.med_id}>{each.med_name}</MenuItem>
                                      )}
                                    </Select>
                                  </FormControl>
                                </div>
                                { this.state.med_anxiolytics[index].med > 0 &&
                                <div className="small-12 medium-8 columns q4_each">
                                  <div className="row">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        Are you currently taking this medication?
                                      </div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_anxio_taking"+index+each.value} >
                                            <input type="radio" value={each.value}
                                                checked={this.state.med_anxiolytics[index].taking == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_anxiolytics', index, 'taking')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  { this.state.med_anxiolytics[index].taking == 1 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        What is the recommended total daily dose?
                                      </div>
                                      <div className="med_q1_ans">
                                        <TextField label="" type="number"
                                        onChange={(e) => this.handleChange5_1(e, 'med_anxiolytics', index, 'dose')}
                                        variant="outlined" value={this.state.med_anxiolytics[index].dose}
                                        InputProps={{ maxLength: 10 }}  />
                                      </div>
                                      <div className="med_q1_detail">mg</div>
                                    </div>
                                  </div>}
                                  { this.state.med_anxiolytics[index].taking == 2 &&
                                  <div className="row top_space2">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Taken for at least 3 months?</div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1"><input type="radio"
                                                key={"at_anxio"+index+each.value} value={each.value}
                                                checked={this.state.med_anxiolytics[index].taken == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_anxiolytics', index, 'taken')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>}
                                  { this.state.med_anxiolytics[index].taking == 2 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Reason for stopping</div>
                                      <div className="med_q1_ans q4_reason">
                                      <FormControl variant="outlined">
                                        <Select value={this.state.med_anxiolytics[index].reason} variant="outlined"
                                          onChange={(e) => this.handleChange5(e, 'med_anxiolytics', index, 'reason')}>
                                          {reason_stopping.map(each =>
                                            <MenuItem key={"at_anxio_rs"+index+each.value} value={each.value}>{each.label}</MenuItem>
                                          )}
                                        </Select>
                                      </FormControl>
                                      </div>
                                    </div>
                                  </div>}

                                </div>}
                              </div>
                            )} {/* End row */}
                            </div>
                            <div className="small-12 columns sep_line1">&nbsp;</div>
                          </div>
                          <div className="small-12 columns ">
                            <button type="button" className="addInput1"
                               onClick={ () => this.appendInputMedication('med_anxiolytics', this.state.med_anxiolytics) }>
                                Add Another Medication
                            </button>
                          </div>
                        </div>{/*End Category*/}
                        {/* Category 6 */}
                        <div className="q4_category">
                          <div className="small-12 columns frm_space1 title_topic2">
                            Anticholinergic
                          </div>
                          <div className="small-12 columns ">
                            <div className="frm_space2">
                            {this.state.med_anticholinergic.map((val, index) =>
                              <div className="row each_m_set" key={"m_anxio"+val.id} >
                                <div className="small-12 columns sep_line1">&nbsp;</div>
                                <div className="small-12 medium-4 columns float_left">
                                  {val.id > 1 && <CancelIcon onClick={ () => this.removeInputSet1('med_anticholinergic', val.id, this.state.med_anticholinergic) } />}
                                  <FormControl variant="outlined">
                                    <Select value={this.state.med_anticholinergic[index].med} variant="outlined"
                                      label="Select medication"
                                      onChange={(e) => this.handleChange5(e, 'med_anticholinergic', index, 'med')}>
                                      {(this.state.medication_list[med_category.find(y => y.label === "anticholinergic").value] ?? []).map(each =>
                                        <MenuItem key={"anticholinergic"+each.med_id} value={each.med_id}>{each.med_name}</MenuItem>
                                      )}
                                    </Select>
                                  </FormControl>
                                </div>
                                { this.state.med_anticholinergic[index].med > 0 &&
                                <div className="small-12 medium-8 columns q4_each">
                                  <div className="row">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        Are you currently taking this medication?
                                      </div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_antiocho_taking"+index+each.value} >
                                            <input type="radio"
                                                value={each.value}
                                                checked={this.state.med_anticholinergic[index].taking == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_anticholinergic', index, 'taking')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  { this.state.med_anticholinergic[index].taking == 1 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        What is the recommended total daily dose?
                                      </div>
                                      <div className="med_q1_ans">
                                        <TextField label="" type="number"
                                        onChange={(e) => this.handleChange5_1(e, 'med_anticholinergic', index, 'dose')}
                                        variant="outlined" value={this.state.med_anticholinergic[index].dose}
                                        InputProps={{ maxLength: 10 }}  />
                                      </div>
                                      <div className="med_q1_detail">mg</div>
                                    </div>
                                  </div>}
                                  { this.state.med_anticholinergic[index].taking == 2 &&
                                  <div className="row top_space2">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Taken for at least 3 months?</div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1"><input type="radio"
                                                key={"at_anticho"+index+each.value} value={each.value}
                                                checked={this.state.med_anticholinergic[index].taken == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_anticholinergic', index, 'taken')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>}
                                  { this.state.med_anticholinergic[index].taking == 2 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Reason for stopping</div>
                                      <div className="med_q1_ans q4_reason">
                                      <FormControl variant="outlined">
                                        <Select value={this.state.med_anticholinergic[index].reason} variant="outlined"
                                          onChange={(e) => this.handleChange5(e, 'med_anticholinergic', index, 'reason')}>
                                          {reason_stopping.map(each =>
                                            <MenuItem key={"at_antiocho_rs"+index+each.value} value={each.value}>{each.label}</MenuItem>
                                          )}
                                        </Select>
                                      </FormControl>
                                      </div>
                                    </div>
                                  </div>}

                                </div>}
                              </div>
                            )} {/* End row */}
                            </div>
                            <div className="small-12 columns sep_line1">&nbsp;</div>
                          </div>
                          <div className="small-12 columns ">
                            <button type="button" className="addInput1"
                               onClick={ () => this.appendInputMedication('med_anticholinergic', this.state.med_anticholinergic) }>
                                Add Another Medication
                            </button>
                          </div>
                        </div>{/*End Category*/}
                        {/* Category 7 */}
                        <div className="q4_category">
                          <div className="small-12 columns frm_space1 title_topic2">
                            Antihistamine
                          </div>
                          <div className="small-12 columns ">
                            <div className="frm_space2">
                            {this.state.med_antihistamine.map((val, index) =>
                              <div className="row each_m_set" key={"m_mood"+val.id} >
                                <div className="small-12 columns sep_line1">&nbsp;</div>
                                <div className="small-12 medium-4 columns float_left">
                                  {val.id > 1 && <CancelIcon onClick={ () => this.removeInputSet1('med_antihistamine', val.id, this.state.med_antihistamine) } />}
                                  <FormControl variant="outlined">
                                    <Select value={this.state.med_antihistamine[index].med} variant="outlined"
                                      onChange={(e) => this.handleChange5(e, 'med_antihistamine', index, 'med')}>
                                      {(this.state.medication_list[med_category.find(y => y.label === "antihistamine").value] ?? []).map(each =>
                                        <MenuItem key={"antihistamine"+each.med_id} value={each.med_id}>{each.med_name}</MenuItem>
                                      )}
                                    </Select>
                                  </FormControl>
                                </div>
                                { this.state.med_antihistamine[index].med > 0 &&
                                <div className="small-12 medium-8 columns q4_each">
                                  <div className="row">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        Are you currently taking this medication?
                                      </div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1"><input type="radio"
                                                key={"at_his_taking"+index+each.value} value={each.value}
                                                checked={this.state.med_antihistamine[index].taking == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_antihistamine', index, 'taking')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  { this.state.med_antihistamine[index].taking == 1 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        What is the recommended total daily dose?
                                      </div>
                                      <div className="med_q1_ans">
                                        <TextField label="" type="number"
                                        onChange={(e) => this.handleChange5_1(e, 'med_antihistamine', index, 'dose')}
                                        variant="outlined" value={this.state.med_antihistamine[index].dose}
                                        InputProps={{ maxLength: 10 }}  />
                                      </div>
                                      <div className="med_q1_detail">mg</div>
                                    </div>
                                  </div>}
                                  { this.state.med_antihistamine[index].taking == 2 &&
                                  <div className="row top_space2">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Taken for at least 3 months?</div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1"><input type="radio"
                                                key={"at_his_3m"+index+each.value} value={each.value}
                                                checked={this.state.med_antihistamine[index].taken == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_antihistamine', index, 'taken')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>}
                                  { this.state.med_antihistamine[index].taking == 2 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Reason for stopping</div>
                                      <div className="med_q1_ans q4_reason">
                                      <FormControl variant="outlined">
                                        <Select value={this.state.med_antihistamine[index].reason} variant="outlined"
                                          onChange={(e) => this.handleChange5(e, 'med_antihistamine', index, 'reason')}>
                                          {reason_stopping.map(each =>
                                            <MenuItem key={"at_his_rs"+index+each.value} value={each.value}>{each.label}</MenuItem>
                                          )}
                                        </Select>
                                      </FormControl>
                                      </div>
                                    </div>
                                  </div>}
                                </div>}
                              </div>
                            )} {/* End row */}
                            </div>
                          </div>
                        </div>{/*End Category*/}
                        {/* Category 8 */}
                        <div className="q4_category">
                          <div className="small-12 columns frm_space1 title_topic2">
                            Sedatives
                          </div>
                          <div className="small-12 columns ">
                            <div className="frm_space2">
                            {this.state.med_sedatives.map((val, index) =>
                              <div className="row each_m_set" key={"m_sed"+val.id} >
                                <div className="small-12 columns sep_line1">&nbsp;</div>
                                <div className="small-12 medium-4 columns float_left">
                                  {val.id > 1 && <CancelIcon onClick={ () => this.removeInputSet1('med_sedatives', val.id, this.state.med_sedatives) } />}
                                  <FormControl variant="outlined">
                                    <Select value={this.state.med_sedatives[index].med} variant="outlined"
                                      label="Select medication"
                                      onChange={(e) => this.handleChange5(e, 'med_sedatives', index, 'med')}>
                                      {(this.state.medication_list[med_category.find(y => y.label === "sedatives").value] ?? []).map(each =>
                                        <MenuItem key={"sedatives"+each.med_id} value={each.med_id}>{each.med_name}</MenuItem>
                                      )}
                                    </Select>
                                  </FormControl>
                                </div>
                                { this.state.med_sedatives[index].med > 0 &&
                                <div className="small-12 medium-8 columns q4_each">
                                  <div className="row">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        Are you currently taking this medication?
                                      </div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_sed_taking"+index+each.value} >
                                            <input type="radio" value={each.value}
                                                checked={this.state.med_sedatives[index].taking == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_sedatives', index, 'taking')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  { this.state.med_sedatives[index].taking == 1 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        What is the recommended total daily dose?
                                      </div>
                                      <div className="med_q1_ans">
                                        <TextField label="" type="number"
                                        onChange={(e) => this.handleChange5_1(e, 'med_sedatives', index, 'dose')}
                                        variant="outlined" value={this.state.med_sedatives[index].dose}
                                        InputProps={{ maxLength: 10 }}  />
                                      </div>
                                      <div className="med_q1_detail">mg</div>
                                    </div>
                                  </div>}
                                  { this.state.med_sedatives[index].taking == 2 &&
                                  <div className="row top_space2">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Taken for at least 3 months?</div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_sed"+index+each.value} >
                                            <input type="radio" value={each.value}
                                                checked={this.state.med_sedatives[index].taken == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_sedatives', index, 'taken')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>}
                                  { this.state.med_sedatives[index].taking == 2 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Reason for stopping</div>
                                      <div className="med_q1_ans q4_reason">
                                      <FormControl variant="outlined">
                                        <Select value={this.state.med_sedatives[index].reason} variant="outlined"
                                          onChange={(e) => this.handleChange5(e, 'med_sedatives', index, 'reason')}>
                                          {reason_stopping.map(each =>
                                            <MenuItem key={"at_sed_rs"+index+each.value} value={each.value}>{each.label}</MenuItem>
                                          )}
                                        </Select>
                                      </FormControl>
                                      </div>
                                    </div>
                                  </div>}

                                </div>}
                              </div>
                            )} {/* End row */}
                            </div>
                            <div className="small-12 columns sep_line1">&nbsp;</div>
                          </div>
                          <div className="small-12 columns ">
                            <button type="button" className="addInput1"
                               onClick={ () => this.appendInputMedication('med_sedatives', this.state.med_sedatives) }>
                                Add Another Medication
                            </button>
                          </div>
                        </div>{/*End Category*/}
                        {/* Category 9 */}
                        <div className="q4_category">
                          <div className="small-12 columns frm_space1 title_topic2">
                            Other
                          </div>
                          <div className="small-12 columns ">
                            <div className="frm_space2">
                            {this.state.med_other.map((val, index) =>
                              <div className="row each_m_set" key={"m_ot"+val.id} >
                                <div className="small-12 columns sep_line1">&nbsp;</div>
                                <div className="small-12 medium-4 columns med_name">
                                  {val.id > 1 && <CancelIcon onClick={ () => this.removeInputSet1('med_other', val.id, this.state.med_other) } />}
                                  <TextField label="Medication name" onChange={(e) => this.handleChange3(e, 'med_other', index, 'med')}
                                  variant="outlined"  inputProps={{maxLength: 60}} value={this.state.med_other[index].med}/>
                                </div>
                                { this.state.med_other[index].med != '' &&
                                <div className="small-12 medium-8 columns q4_each">
                                  <div className="row">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        Are you currently taking this medication?
                                      </div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_ot_taking"+index+each.value} >
                                            <input type="radio" value={each.value}
                                                checked={this.state.med_other[index].taking == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_other', index, 'taking')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  { this.state.med_other[index].taking == 1 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">
                                        What is the recommended total daily dose?
                                      </div>
                                      <div className="med_q1_ans">
                                        <TextField label="" type="number"
                                        onChange={(e) => this.handleChange5_1(e, 'med_other', index, 'dose')}
                                        variant="outlined" value={this.state.med_other[index].dose}
                                        InputProps={{ maxLength: 10 }}  />
                                      </div>
                                      <div className="med_q1_detail">mg</div>
                                    </div>
                                  </div>}
                                  { this.state.med_other[index].taking == 2 &&
                                  <div className="row top_space2">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Taken for at least 3 months?</div>
                                      <div className="med_q1_ans">
                                        {yes_no.map(each =>
                                          <div className="each_radio1" key={"at_sed"+index+each.value} >
                                            <input type="radio" value={each.value}
                                                checked={this.state.med_other[index].taken == each.value}
                                                onChange={(e) => this.handleChange5(e, 'med_other', index, 'taken')}/>
                                                {each.label}</div>
                                        )}
                                      </div>
                                    </div>
                                  </div>}
                                  { this.state.med_other[index].taking == 2 &&
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Reason for stopping</div>
                                      <div className="med_q1_ans q4_reason">
                                      <FormControl variant="outlined">
                                        <Select value={this.state.med_other[index].reason} variant="outlined"
                                          onChange={(e) => this.handleChange5(e, 'med_other', index, 'reason')}>
                                          {reason_stopping.map(each =>
                                            <MenuItem key={"at_ot_rs"+index+each.value} value={each.value}>{each.label}</MenuItem>
                                          )}
                                        </Select>
                                      </FormControl>
                                      </div>
                                    </div>
                                  </div>}

                                </div>}
                              </div>
                            )} {/* End row */}
                            </div>
                            <div className="small-12 columns sep_line1">&nbsp;</div>
                          </div>
                          <div className="small-12 columns ">
                            <button type="button" className="addInput1"
                               onClick={ () => this.appendInputMedication2('med_other', this.state.med_other) }>
                                Add Another Medication
                            </button>
                          </div>
                        </div>{/*End Category*/}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="small-12 columns box1 q4">
                    <div className="title_topic1">5. Please list any non-psychiatric medications you are currently taking:</div>
                    <div className="row">
                      <div className="small-12 columns">
                        {/* Category 1 */}
                        <div className="q4_category">
                          <div className="small-12 columns ">
                            <div className="frm_space3">
                            {this.state.nonpsyciatric_med.map((val, index) =>
                              <div className="row each_m_set" key={"m_non"+val.id} >
                                <div className="small-12 medium-4 columns med_name">
                                  {val.id > 1 && <CancelIcon onClick={ () => this.removeInputSet1('nonpsyciatric_med', val.id, this.state.nonpsyciatric_med) } />}
                                  <TextField label="Medication name" onChange={(e) => this.handleChange3(e, 'nonpsyciatric_med', index, 'med')}
                                  variant="outlined"  inputProps={{maxLength: 60}} value={this.state.nonpsyciatric_med[index].med}/>
                                </div>
                                { this.state.nonpsyciatric_med[index].med != '' &&
                                <div className="small-12 medium-8 columns q4_each">
                                  <div className="row top_space">
                                    <div className="small-12 columns">
                                      <div className="med_q1">Total daily dosage:</div>
                                      <div className="med_q1_ans">
                                        <TextField label="" type="number" value={this.state.nonpsyciatric_med[index].dose}
                                        onChange={(e) => this.handleChange5_1(e, 'nonpsyciatric_med', index, 'dose')}
                                        variant="outlined" value={this.state.nonpsyciatric_med[index].dose}
                                        InputProps={{ maxLength: 10 }}  />
                                      </div>
                                      <div className="med_q1_detail">mg</div>
                                    </div>
                                  </div>
                                </div>}
                                <div className="small-12 columns sep_line1">&nbsp;</div>
                              </div>
                            )} {/* End row */}
                            </div>
                          </div>
                          <div className="small-12 columns ">
                            <button type="button" className="addInput1"
                               onClick={ () => this.appendInputMedication3('nonpsyciatric_med', this.state.nonpsyciatric_med) }>
                                Add Another Medication
                            </button>
                          </div>
                        </div>{/*End Category*/}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="small-12 columns box1">
                    <div className="title_topic1">
                      6. Have you ever been diagnosed with the following?
                    </div>

                    <div className="row">
                      <div className="small-12 columns frm_space1">
                        {diagnosed.map(each => {
                          const fieldName = `diagnosed_${each.value}`;
                          const isYes = Number(this.state[fieldName]) === 1;

                          return (
                            <div className="each_checkbox" key={fieldName}>
                              <div className="row">
                                <div className="small-12 columns">
                                  <div className="title_topic2">{each.label}</div>

                                  <div className="frm_space1">
                                    {yes_no.map(option => (
                                      <label
                                        className="each_radio1"
                                        key={`${fieldName}_${option.value}`}
                                      >
                                        <input
                                          type="radio"
                                          name={fieldName}
                                          value={option.value}
                                          checked={
                                            Number(this.state[fieldName]) ===
                                            Number(option.value)
                                          }
                                          onChange={this.handleChange2}
                                        />
                                        {option.label}
                                      </label>
                                    ))}
                                  </div>
                                </div>

                                {/* Brain injury */}
                                {isYes && Number(each.value) === 1 && (
                                  <div className="small-12 columns">
                                    <div className="med_q1_detail">
                                      <ArrowRightIcon />
                                      Approximate date of most recent injury
                                    </div>

                                    <div className="med_q1_detail">
                                      <TextField
                                        name="diagnosed_brain_date"
                                        value={this.state.diagnosed_brain_date}
                                        onChange={this.handleChange}
                                        variant="outlined"
                                        inputProps={{ maxLength: 40 }}
                                      />
                                    </div>

                                    <div className="med_q1_detail">
                                      <ArrowRightIcon /> Please describe
                                    </div>

                                    <div className="med_q1_detail2">
                                      <TextField
                                        name="diagnosed_brain_text"
                                        value={this.state.diagnosed_brain_text}
                                        onChange={this.handleChange}
                                        variant="outlined"
                                        inputProps={{ maxLength: 50 }}
                                      />
                                    </div>
                                  </div>
                                )}

                                {/* Diabetes */}
                                {isYes && Number(each.value) === 2 && (
                                  <div className="small-12 columns">
                                    <div className="med_q1_detail">
                                      <ArrowRightIcon /> Type of diabetes
                                    </div>

                                    <div className="med_q1_detail">
                                      <FormControl variant="outlined">
                                        <Select
                                          value={this.state.diagnosed_diabetes}
                                          className="diabetes"
                                          onChange={e =>
                                            this.handleChange4(e, 'diagnosed_diabetes')
                                          }
                                        >
                                          {diabetes.map(option => (
                                            <MenuItem
                                              key={`diabetes_${option.value}`}
                                              value={option.value}
                                            >
                                              {option.label}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  </div>
                                )}

                                {/* Hypertension */}
                                {isYes && Number(each.value) === 3 && (
                                  <div className="small-12 columns">
                                    <div className="med_q1_detail">
                                      <ArrowRightIcon />
                                      Are you currently being treated for high blood
                                      pressure with medication(s)?
                                    </div>

                                    <div className="med_q1_detail">
                                      <FormControl variant="outlined">
                                        <Select
                                          value={this.state.diagnosed_hypertension}
                                          className="diabetes"
                                          onChange={e =>
                                            this.handleChange4(e, 'diagnosed_hypertension')
                                          }
                                        >
                                          {hypertension.map(option => (
                                            <MenuItem
                                              key={`hypertension_${option.value}`}
                                              value={option.value}
                                            >
                                              {option.label}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  </div>
                                )}

                                {/* Cancer */}
                                {isYes && Number(each.value) === 15 && (
                                  <div className="small-12 columns">
                                    <div>
                                      <ArrowRightIcon /> Please describe
                                    </div>

                                    <TextField
                                      name="diagnosed_cancer_txt"
                                      value={this.state.diagnosed_cancer_txt}
                                      onChange={this.handleChange}
                                      variant="outlined"
                                      inputProps={{ maxLength: 200 }}
                                    />
                                  </div>
                                )}

                                {/* Other medical condition */}
                                {isYes && Number(each.value) === 23 && (
                                  <div className="small-12 columns">
                                    <div>
                                      <ArrowRightIcon />
                                      Please write in your medical condition
                                    </div>

                                    <TextField
                                      name="diagnosed_other"
                                      value={this.state.diagnosed_other}
                                      onChange={this.handleChange}
                                      variant="outlined"
                                      inputProps={{ maxLength: 200 }}
                                    />
                                  </div>
                                )}
                              </div><div className="sep_line2">&nbsp;</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                {/*<div className="row">
                  <div className="small-12 columns box1">
                    <div className="title_topic1">6. Have you ever been diagnosed with the following?</div>
                    <div className="row">
                      <div className="small-12 columns frm_space1">

                        <div className="each_checkbox">
                          <div className="row">
                            <div className="small-12 columns">
                              <input type="checkbox" name="diagnosed_1"
                                value={diagnosed[0].value}
                                onChange={(e) => this.handleChange7(e)}/>
                                {diagnosed[0].label}
                            </div>
                            { this.state.diagnosed_1 == 1 &&
                            <div>
                              <div className="small-12 columns">
                                <div className="med_q1_detail">
                                  <ArrowRightIcon /> Approximate date of most recent injury
                                </div>
                                <div className="med_q1_detail">
                                  <TextField name="diagnosed_brain_date"
                                  onChange={(e) => this.handleChange(e)} value={this.state.diagnosed_brain_date}
                                  variant="outlined"  inputProps={{maxLength: 40}} />
                                </div>
                              </div>
                              <div className="small-12 columns">
                                <div className="med_q1_detail">
                                  <ArrowRightIcon /> Please describe
                                </div>
                                <div className="med_q1_detail2">
                                  <TextField name="diagnosed_brain_text" value={this.state.diagnosed_brain_text}
                                  onChange={(e) => this.handleChange(e)}
                                  variant="outlined"  inputProps={{maxLength: 50}} />
                                </div>
                              </div>
                            </div>
                            }
                          </div>
                        </div>

                        <div className="each_checkbox">
                        <div className="row">
                          <div className="small-12 columns">
                            <input type="checkbox" name="diagnosed_2"
                              value={diagnosed[1].value}
                              onChange={(e) => this.handleChange7(e)}/>
                              {diagnosed[1].label}
                          </div>
                          { this.state.diagnosed_2 == 1 &&
                            <div className="small-12 columns">
                              <div className="med_q1_detail"><ArrowRightIcon /> Type of diabetes</div>
                              <div className="med_q1_detail">
                                <FormControl variant="outlined">
                                  <Select value={this.state.diagnosed_diabetes} variant="outlined" className="diabetes"
                                    onChange={(e) => this.handleChange4(e, 'diagnosed_diabetes')}>
                                      {diabetes.map(each =>
                                        <MenuItem key={"diabetes"+each.value} value={each.value}>{each.label}</MenuItem>
                                      )}
                                  </Select>
                                </FormControl>
                              </div>
                            </div>}
                          </div>
                        </div>

                        <div className="each_checkbox">
                          <div className="row">
                            <div className="small-12 columns">
                              <input type="checkbox" name="diagnosed_3"
                                value={diagnosed[2].value}
                                onChange={(e) => this.handleChange7(e)}/>
                                {diagnosed[2].label}
                            </div>
                            { this.state.diagnosed_3 == 1 &&
                            <div className="small-12 columns">
                              <div className="med_q1_detail"><ArrowRightIcon /> Are you currently being treated for high blood pressure with medication(s)?</div>
                              <div className="med_q1_detail">
                                <FormControl variant="outlined">
                                  <Select value={this.state.diagnosed_hypertension} variant="outlined" className="diabetes"
                                    onChange={(e) => this.handleChange4(e, 'diagnosed_hypertension')}>
                                      {hypertension.map(each =>
                                        <MenuItem key={"hypertension"+each.value} value={each.value}>{each.label}</MenuItem>
                                      )}
                                  </Select>
                                </FormControl>
                              </div>
                            </div>}
                          </div>
                        </div>

                        {diagnosed.map(each =>
                          each.value > 3 && each.value <15 &&
                          <div className="each_checkbox" id={"dg"+each.value} key={"diagnosed"+each.value} >
                            <div className="med_q1_detail">
                              <input type="checkbox" name={"diagnosed_"+each.value}
                                value={each.value}
                                onChange={(e) => this.handleChange7(e)}/>
                                {each.label}
                            </div>
                          </div>
                        )}

                        <div className="each_checkbox">
                          <div className="row">
                            <div className="small-12 columns">
                              <input type="checkbox" name="diagnosed_15"
                                value={diagnosed[14].value}
                                onChange={(e) => this.handleChange7(e)}/>
                                {diagnosed[14].label}
                            </div>
                            { this.state.diagnosed_15 == 1 &&
                              <div className="small-12 columns">
                                <div className="small-12 columns">
                                  <ArrowRightIcon /> Please describe
                                </div>
                                <div className="small-12 columns">
                                <TextField name="diagnosed_cancer_txt" value={this.state.diagnosed_cancer_txt}
                                onChange={(e) => this.handleChange(e)}
                                variant="outlined"  inputProps={{maxLength: 200}} />
                                </div>
                              </div>
                            }
                          </div>
                        </div>

                        {diagnosed.map(each =>
                          each.value > 15 && each.value <23 &&
                          <div className="each_checkbox" id={"dg"+each.value} key={"diagnosed"+each.value} >
                            <div className="med_q1_detail">
                              <input type="checkbox" name={"diagnosed_"+each.value}
                                value={each.value}
                                onChange={(e) => this.handleChange7(e)}/>
                                {each.label}
                            </div>
                          </div>
                        )}

                        <div className="each_checkbox">
                          <div className="row">
                            <div className="small-12 columns">
                              <input type="checkbox" name="diagnosed_23"
                                value={diagnosed[22].value}
                                onChange={(e) => this.handleChange7(e)}/>
                                {diagnosed[22].label}
                            </div>
                            { this.state.diagnosed_23 == 1 &&
                              <div className="small-12 columns">
                                <div className="small-12 columns">
                                  <ArrowRightIcon /> Please write in your medical condition
                                </div>
                                <div className="small-12 columns">
                                <TextField name="diagnosed_other" value={this.state.diagnosed_other}
                                onChange={(e) => this.handleChange(e)}
                                variant="outlined"  inputProps={{maxLength: 200}} />
                                </div>
                              </div>
                            }
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>*/}

              <div className="row">
                <div className="small-12 columns align_right">
                {this.state.status_submit &&
                  <Button variant="contained" color="primary" disableElevation
                   onClick={this.handleSubmit} type="button" className="submit_1">
                    Submit
                  </Button>}
                {!this.state.status_submit &&
                  <Button variant="contained" disabled
                   onClick={this.handleSubmit} type="button" className="submit_1">
                    Submit
                  </Button>}
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('patientstate STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(MedicalHistory)
